module.exports = __webpack_public_path__ + "img/logos_mobile_9.b76f96b9.png";